import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import FolderIcon from '@material-ui/icons/Folder';
import { Link } from 'react-router-dom';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import Tooltip from '@material-ui/core/Tooltip';
import TitleComponent from '../../common/titleComponent';
import { Divider, Paper } from '@material-ui/core';

const ProjectList = ({ data: projects }) => {
  return (
    
    <Paper className='paper'>
      <TitleComponent entity={'Proyectos'} />
      <Divider />
      <div>
        <List dense={true}>
          {projects.length > 0 ? (
            projects.map((project) => (
              <ListItem divider key={project.id}>
                <ListItemAvatar>
                  <Avatar>
                    <FolderIcon />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={
                    <>
                      <Link
                        to={'/proyecto/' + project.slug}
                        style={{ textDecoration: 'none' }}
                      >
                        {project.name}
                      </Link>
                    </>
                  }
                  secondary={
                    <>
                      <Tooltip title={project.updated_at}>
                        <span variant='caption'>
                          Última actualización:
                          {project.human_updated_at}
                        </span>
                      </Tooltip>
                    </>
                  }
                />
              </ListItem>
            ))
          ) : (
            <ListItem>
              <ListItemText
                primary={'No existen proyectos asociados a tu perfil'}
              />
            </ListItem>
          )}
        </List>
      </div>
      </Paper>    
  );
};

export default ProjectList;
